/** Dynamo date_gpid keys on GenAI items (metric 20, 23, 25, highlights). */
export const GENAI_REVIEW_ID_FIELDS = [
  "associated_gpids",
  "associatedGpids",
  "associated_review_ids",
  "associatedReviewIds",
  "representative_review_ids",
  "representativeReviewIds",
  "review_ids",
  "reviewIds",
  "related_review_ids",
  "relatedReviewIds",
  "review_refs",
  "reviewRefs",
];

export function collectGenaiItemReviewIds(item, max = 80) {
  if (!item || typeof item !== "object") return [];
  const out = [];
  const seen = new Set();
  const push = (v) => {
    const s = String(v ?? "").trim();
    if (!s || seen.has(s)) return;
    seen.add(s);
    out.push(s);
  };
  const takeScalarList = (raw) => {
    if (raw == null) return;
    if (Array.isArray(raw)) {
      for (const x of raw) {
        if (out.length >= max) break;
        if (x != null && typeof x === "object" && !Array.isArray(x)) {
          const id =
            x.review_id ?? x.date_gpid ?? x.id ?? x.ref ?? x.gpid ?? x.reviewId;
          if (id != null) push(id);
        } else push(x);
      }
    } else if (typeof raw === "string") {
      for (const part of raw.split(/[\s,]+/)) {
        if (out.length >= max) break;
        push(part);
      }
    } else push(raw);
  };

  for (const key of GENAI_REVIEW_ID_FIELDS) {
    if (out.length >= max) break;
    takeScalarList(item[key]);
  }
  return out;
}
